export enum ReportStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}

export enum ReportDetailStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED'
}
